const {Ajax, AJAX_OPTION} = Mutil;

//COLABO_USER_DUPLICATE_R001
export async function checkDuplicateEmail(email) {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    let result;
    try {
        result = await ajaxSpace.executeApi("COLABO_USER_DUPLICATE_R001", {USER_ID: email});
    } catch (e) {
        console.error(`ERROR in sendAuthNumberToEmail : ${e.DATA.ERROR_MESSAGE}`);
    }
    return result;
}


export async function sendAuthNumberToEmail(authInfo) {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    let result;
    try {
        result = await ajaxSpace.executeApi("FLOW_AUTH_NO_CHECK_R002", {...authInfo});
    } catch (e) {
        console.error(`ERROR in sendAuthNumberToEmail : ${e.DATA.ERROR_MESSAGE}`);
    }
    return result;
}

export async function findInviterList(userId) {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    let result;
    try {
        result = await ajaxSpace.executeApi("ACT_FIND_TEAM_INVT_R001", {USER_ID: userId});
    } catch (e) {
        console.error(`ERROR in findInviterList : ${e}`);
    }
    return result;
}


export async function checkAuthNum(authInfo,) {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    let result;
    try {
        result = await ajaxSpace.executeApi("FLOW_AUTH_NO_CHECK_R001", {...authInfo});

    } catch (e) {
        console.error(`ERROR in checkAuthNum : ${e.DATA.ERROR_MESSAGE}`);
    }
    return result;
}

export async function checkSubDomain(subDomain = "") {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    let result;
    try {
        result = await ajaxSpace.executeApi("FLOW_SUB_DOM_R001", {SUB_DOM: subDomain});
    } catch (e) {
        console.error(`ERROR in checkSubDomain : ${e.DATA.ERROR_MESSAGE}`);
    }
    return result;
}
export async function getCompanyInfo(useInttId = "") {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    let result;
    try {
        result = await ajaxSpace.executeApi("ACT_COMPANY_INFO", {USE_INTT_ID: useInttId});
    } catch (e) {
        console.error(`ERROR in getCompanyInfo : ${e.DATA.ERROR_MESSAGE}`);
    }
    return result;
}
export async function cancelCompanyJoinRequest(userId = "") {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    let result;
    try {
        result = await ajaxSpace.executeApi("ACT_CANCEL_COMPANY_JOIN_REQUEST", {USER_ID: userId});
    } catch (e) {
        console.error(`ERROR in cancelCompanyJoinRequest : ${e.DATA.ERROR_MESSAGE}`);
    }
    return result;
}

export async function registerUserByUserInfo(userInfo) {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    let result;
    try {
        result = await ajaxSpace.executeApi("COLABO2_REGISTER_C001", {...userInfo});
    } catch (e) {
        console.error(`ERROR in cancelCompanyJoinRequest : ${e.DATA.ERROR_MESSAGE}`);
    }
    return result;
}

export async function createNewCompany(userInfo) {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    let result;
    try {
        result = await ajaxSpace.executeApi("FLOW_SUB_DOM_C001", {...userInfo});
    } catch (e) {
        console.error(`ERROR in cancelCompanyJoinRequest : ${e.DATA.ERROR_MESSAGE}`);
    }

    return result;
}